import React, { Component } from 'react';
import auth from '../../Auth/firebase-auth';

class Admin extends Component {
  constructor (props, context) {
    super (props, context);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      error: null
    }
  }

  static contextTypes = {
    router: React.PropTypes.object
  }

  handleSubmit (e) {
    e.preventDefault();
    auth.login(this.refs.email.value, this.refs.password.value, (user, err) => {
      if (user) {
        console.log('successfully signed in');
        this.context.router.push('/')
      }
      if (err) {
        this.refs.email.value = "";
        this.refs.password.value = "";
        this.setState({
          error: err.message
        });
      }
    });
  }

  render () {
    return (
      <div>
        <h2>Admin</h2>
        <div className="login-form-container col-md-6 col-md-offset-3">
          <form className="form" onSubmit={this.handleSubmit}>
            <h2>Login</h2>
            <div className="form-group">
              <label>Email:</label>
              <input className="form-control" type="email" ref="email" placeholder="Email" required />
            </div>
            <div className="form-group">
              <label>Password:</label>
              <input className="form-control" type="password" ref="password" placeholder="Password" required />
            </div>
            { this.state.error ? <div><p className="text-warning">{ this.state.error }</p></div> : null }
            <div className="form-group">
              <button type="submit" className="btn btn-default" >Login</button>
            </div>
          </form>
        </div>
      </div>
    );
  }

}

export default Admin;



/** WEBPACK FOOTER **
 ** ./src/components/Pages/Admin.js
 **/